import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";

// Icons
import backIcon from "../../assets/icons/icons-back.svg";
import kulpaIchip from "../../assets/icons/kulpaIchip.svg";

// Config
import colors from "../../config/colors";

// Hooks
import useTranslate from "../../hooks/useTranslate";

// Components
import Button from "../Button";
import Text from "../Text";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4, 3),
    display: "flex",
    flexDirection: "column",
    maxWidth: 400
  },
  iconButton: {
    marginRight: "auto"
  },
  defaultIcon: {
    margin: "0 auto",
    width: 120
  },
  title: {
    padding: theme.spacing(2, 0, 1),
    lineHeight: 1.1,
    maxWidth: 220,
    margin: "0 auto"
  },
  paragraph: {
    color: colors.lynch,
    marginBottom: theme.spacing(3),
    padding: theme.spacing(0, 2),
    opacity: 0.7,
    lineHeight: 1.5
  },
  button: {
    margin: theme.spacing(0, 3),
    textTransform: "uppercase",
    cursor: "pointer",
    background:
      "transparent linear-gradient(76deg, #452CFC 0%, #23167E 100%) 0% 0% no-repeat padding-box"
  }
}));

const defaultParagraphs = ["createCasePage.safeSpace.p1"];

const IntelMode = ({ userType, onCancel, onClick }) => {
  const classes = useStyles();
  const getText = useTranslate();

  const contents = {
    default: {
      icon: kulpaIchip,
      iconClass: classes.defaultIcon,
      title: "createCasePage.safeSpace.title",
      paragraphs: defaultParagraphs
    }
  };

  const content = contents[userType] || contents.default;

  return (
    <div className={classes.root}>
      <IconButton className={classes.iconButton} onClick={onCancel}>
        <img src={backIcon} alt="" />
      </IconButton>
      <img alt="" className={content.iconClass} src={content.icon} />
      <Text
        align="center"
        className={classes.title}
        values={{
          1: "Kulpa i"
        }}
        text="createCasePage.intelligenceMode.title"
        type="heading2"
      />
      <Text
        align="center"
        className={classes.paragraph}
        text="createCasePage.intelligenceMode.body"
        type="subtitle1Small"
      />
      <Button
        className={classes.button}
        color="primary"
        disableElevation
        onClick={onClick}
        variant="contained"
      >
        {getText("common.prompts.ok")}
      </Button>
    </div>
  );
};

IntelMode.propTypes = {
  userType: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
};

export default IntelMode;
